import { cond, always, T, F, } from 'ramda';
import { isEmpty } from 'App/helpers'

export const fields = {
  taxSituation: {
    input: {
      value: '',
      name: 'taxSituation',
      accept: 'application/pdf',
    },
    label: 'Documento que acreedite el TAX ID de su país.',
    validate: cond([
      [isEmpty, always({ error: 'Este campo es requerido' })],
      [T, F]
    ]),
  },
  addressProof: {
    input: {
      value: '',
      name: 'addressProof',
      accept: 'application/pdf',
    },
    label: 'Comprobante de Domicilio',
    validate: cond([
      [isEmpty, always({ error: 'Este campo es requerido' })],
      [T, F]
    ]),
  },
  id: {
    input: {
      value: '',
      name: 'id',
      accept: 'application/pdf',
    },
    label: 'Identificación Oficial (Pasaporte o residencia en México)',
    validate: cond([
      [isEmpty, always({ error: 'Este campo es requerido' })],
      [T, F]
    ]),
  },

  id_personal_data: {
    input: {
      value: '',
      name: 'id_personal_data',
    },

  }

};
